<template>
  <div class="categories" v-show="isIpad" :class="{ styleChanged: showTab }">
    <div class="tab-holder" v-show="showTab">
      <div class="links">
        <i class="fas fa-chevron-up" @click="closeTab()"></i>
        <router-link
          @click="closeTab()"
          :to="
            $staffI18nRoute({
              name: 'Articles',
              params: { status: 'published' },
            })
          "
          class="article-tab-switcher"
        >
          <div class="label" :class="{ colorChanged: route.params?.status === 'published' }">{{ $t("admin.published_news") }}</div>
          <div class="count">{{ user.published_count }}</div>
        </router-link>
        <router-link
          @click="closeTab()"
          :to="
            $staffI18nRoute({
              name: 'Articles',
              params: { status: 'moderation' },
            })
          "
          class="article-tab-switcher"
        >
          <svg width="4" height="4">
            <circle
              xmlns="http://www.w3.org/2000/svg"
              cx="2"
              cy="2"
              r="2"
              fill="#FFC24A"
            />
          </svg>
          <div class="label" :class="{ colorChanged: route.params?.status === 'moderation' }">{{ $t("admin.moderation") }}</div>
          <div class="count">{{ user.moderation_count }}</div>
        </router-link>
        <router-link
          @click="closeTab()"
          :to="
            $staffI18nRoute({
              name: 'Articles',
              params: { status: 'declined' },
            })
          "
          class="article-tab-switcher"
        >
          <svg width="4" height="4">
            <circle
              xmlns="http://www.w3.org/2000/svg"
              cx="2"
              cy="2"
              r="2"
              fill="#FF6969"
            />
            >
          </svg>
          <div class="label" :class="{ colorChanged: route.params?.status === 'declined' }">{{ $t("admin.rejected") }}</div>
          <div class="count">{{ user.declined_count }}</div>
        </router-link>
        <router-link
          @click="closeTab()"
          :to="
            $staffI18nRoute({
              name: 'Articles',
              params: { status: 'draft' },
            })
          "
          class="article-tab-switcher"
        >
          <div class="label" :class="{ colorChanged: route.params?.status === 'draft' }">
            {{ $t("admin.drafts") }}
          </div>
          <div class="count">{{ user.draft_count }}</div>
        </router-link>
      </div>
    </div>
    <button @click="openTab()" v-if="!showTab">
      <i class="fas fa-chevron-down"></i>
      <h2 v-if="route.params.status == 'published'">
        {{ $t("admin.published_news") }}
        <span>{{ user.published_count }}</span>
      </h2>
      <h2 v-if="route.params.status == 'moderation'">
        {{ $t("admin.moderation") }}
        <span> {{ user.moderation_count }} </span>
      </h2>
      <h2 v-if="route.params.status == 'declined'">
        {{ $t("admin.rejected") }}
        <span>
          {{ user.declined_count }}
        </span>
      </h2>
      <h2 v-if="route.params.status == 'draft'">
        {{ $t("admin.drafts") }} <span>{{ user.draft_count }}</span>
      </h2>
    </button>
  </div>
</template>

<script>
import { computed, ref, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
export default {
  setup() {
    const store = useStore();
    const route = useRoute();

    const isIpad = ref();

    if (typeof window !== "undefined") {
      isIpad.value = window.innerWidth <= 1366;
      window.addEventListener("resize", handleResize);
    }

    const handleResize = () => {
      isIpad.value = window.innerWidth <= 1366;
    };

    onBeforeUnmount(() => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handleResize);
      }
    });

    const showTab = ref(false);

    const openTab = () => {
      showTab.value = true;
    };
    const closeTab = () => {
      showTab.value = false;
    };

    return {
      user: computed(() => store.getters.user),
      openTab,
      closeTab,
      showTab,
      isIpad,
      route,
    };
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
  .categories {
    background-color: rgba(245, 245, 245, 1);
    transition: all 0.4s ease;
    display: flex;
    align-items: center;
    position: absolute;
    top: -0.1vw;
    left: 0;
    right: 0;
    z-index: 1;

    .tab-holder {
      display: flex;
      flex-direction: column;
      transition: all 0.4s ease;
      position: relative;
      i {
        position: absolute;
        top: 1.85vw;
        font-size: 3vw;
        color: #b4bbc3;
        z-index: 1;
        cursor: pointer;
      }
      .links {
        padding-left: 3vw;
        .article-tab-switcher {
          width: 100%;
          height: 3.646vw;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          transition: all 0.4s ease;
          transition: all 0.4s ease;
          font-size: 2.604vw;
          line-height: 3.125vw;
          margin-bottom: 3.255vw;
          margin-top: 1.432vw;
          svg {
            margin-left: 2.083vw;
          }
          .label {
            flex: 1 0 0;
            color: #586574;
            font-size: 2.604vw;
            line-height: 3.125vw;
            margin-left: 1.5vw;
            &:nth-child(1) {
              margin-left: 4vw;
            }


            &.colorChanged{
        color: #3b71bc;
            }
          }

          .count {
            margin-right: 0.781vw;
            font-weight: 100;
            font-size: 2.604vw;
            line-height: 3.125vw;
            color: rgba(114, 127, 142, 1);
            padding-right: 13.021vw;
          }

          &:nth-child(4) {
            margin-bottom: 1.953vw;
          }
        }
      }
    }
    button {
      outline: none;
      border: none;
      cursor: pointer;
      background: transparent;
      display: flex;
      width: 100%;
      height: 4.859vw;
      margin-top: 2vw;
      i {
        color: #b4bbc3;
        margin-left: 2.2vw;
        font-size: 3.246vw;
        width: 4.688vw;
        outline: none;
        margin-top: -0.2vw;
      }

      h2 {
        font-size: 2.604vw;
        line-height: 2.604vw;
        color: #3b71bc;
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin-left: 0.5vw;

        span {
          margin-right: 13.821vw;
          color: rgba(114, 127, 142, 1);
          font-size: 2.604vw;
          line-height: 2.604vw;
          font-weight: 400;
        }
      }
    }


    &.styleChanged {
      .tab-holder {
        height: 25.833vw;
        padding: 0;
        width: 100%;
      }
    }
  }
}

@media screen and (max-width: 414px) {
  .categories {
    .tab-holder {
      .links {
        i {
          left: 5.333vw;
          top: 1.8vw;
        }
        .article-tab-switcher {
          padding-left: 0rem;
          width: 100%;
          margin-bottom: 4.667vw;

          font-size: 5.333vw;
          line-height: 6.4vw;

          svg {
            margin-left: 5vw;
          }

          .label {
            padding-left: 1vw;

            &:nth-child(1) {
              margin-left: 7.5vw;
            }
          }

          .count {
            padding-right: 2.667vw;
          }

          &:nth-child(4) {
            margin-bottom: 15px;
          }
        }
      }
    }
    button {
      width: 100%;
      height: 5vw;

      h2 {
        width: 100%;
        margin-left: 3.2vw;
        span {
          margin-right: 3.4vw;
        }
      }
      i {
        margin-left: 4.267vw;
        margin-top: 0;
      }
    }

    &.styleChanged {
      width: 100%;
      height: 34vw;
      align-items: flex-start;
    }
  }
}
</style>